<template>
	<el-row :gutter="10" class="stat-numbers common" style="font-family: Bebas Neue;">
		<el-col :span="6">
			<router-link :to="{ name: 'classgradeManagement' }">
				<div class="number-block number-block-class">
					<div class="caption">
						<span>管辖班级</span
						><svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-iconoutlinearrowenter"></use>
						</svg>
					</div>
					<p>{{ mgnClassNumber }}<span>个</span></p>
				</div></router-link
			>
		</el-col>
		<el-col :span="6">
			<router-link :to="{ name: 'studentManagement' }">
				<div class="number-block number-block-student">
					<div class="caption">
						<span>管辖学生</span
						><svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-iconoutlinearrowenter"></use>
						</svg>
					</div>
					<p>{{ mgnStudentNumber }}<span>名</span></p>
				</div></router-link
			>
		</el-col>
		<el-col :span="6">
			<router-link :to="{ name: 'teacherManagement' }">
				<div class="number-block number-block-student">
					<div class="caption">
						<span>管辖教师</span
						><svg class="icon" aria-hidden="true">
							<use xlink:href="#icon-iconoutlinearrowenter"></use>
						</svg>
					</div>
					<p>{{ mgnTeacherNumber }} <span>名</span></p>
				</div></router-link
			>
		</el-col>
		<el-col :span="6">
			<div class="number-block number-block-student">
				<div class="caption">
					<span>离线码</span>
				</div>
				<p>{{ mgnShcoolCode }}</p>
			</div>
		</el-col>
	</el-row>
</template>

<script>
export default {
	data() {
		return {
			mgnClassNumber: '-',
			mgnStudentNumber: '-',
			mgnTeacherNumber: '-',
			mgnShcoolCode: '-'
		}
	},
	created() {
		// 数字
		this.$api.school_admin.show(this.$store.state.user.userInfo.id).then(res => {
			this.mgnClassNumber = res.school.class_grades_count
			this.mgnStudentNumber = res.school.students_count
			this.mgnTeacherNumber = res.school.teachers_count
			this.mgnShcoolCode = res.school.school_code
		})
	}
}
</script>

<style></style>
